import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doBATCH_ADD_PARTICIPANT} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PARTICIPANT_CREATE = 'REQUEST_PARTICIPANT_CREATE'
export const doREQUEST_PARTICIPANT_CREATE = createDoRequestAction(REQUEST_PARTICIPANT_CREATE)

export const requestParticipantCreateActionCreators = {
  doREQUEST_PARTICIPANT_CREATE,
}

export function* requestParticipantCreate({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestParticipantCreate')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        batchId: v.string().uuid().exist(),
        insignia: v.string().optional().allow('', null),
        note: v.string().optional().allow('', null),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {batchId, note, insignia} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v2/web/participant-create`,
    accessToken,
    data: {
      batchId,
      insignia,
      note,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v2/web/participant-create',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doBATCH_ADD_PARTICIPANT({
      batchId: result.payload.batchId,
      participant: result.payload,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PARTICIPANT_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* participantCreateSaga() {
  yield takeEvery(REQUEST_PARTICIPANT_CREATE as any, requestParticipantCreate)
}
